import React from 'react';
import { Input } from '../../components/ui/input';
import { DatePickerFr } from '../../components/ui/DatePickerFr';
import { Label } from '../../components/ui/label';
import { Calculator, Calendar, List, Plus, Trash2} from 'lucide-react';
export default function ResultatsAdminPanels({
  resultat, modeCalcul, modeSimulateur, user, formData,
  contratParent, walletBalance, creditCostPdf, hasEnoughCredits, loadingDevis,
  handleDownloadDevisSimulation, handleSouscrire, handleCreerAvenant, propositionConversion, handleSouscrireFromProposition,
  dismissPropositionConversion, isFtpeMember, loading, selectedActivitesPIB = [], selectedActivitesGO = [],
  selectedActivites2nd = [], selectedActivitesTP = [], montantsPersonnalises, setMontantsPersonnalises, getMontantsFinals,
  getTaxesFinals, taxesPersonnalisees, setTaxesPersonnalisees, isSuperAdmin, isAdminOrSuperAdmin,
  validitePersonnalisee, setValiditePersonnalisee, updateLigneTaxe, supprimerLigneTaxe, ajouterLigneTaxe,
  remiseSolidaireNegociee = null, onEcheancierPlanChange = null, signatureModalOpen, setSignatureModalOpen}) {
  return (
    <>
                    {isSuperAdmin && (
                      <div className="bg-gradient-to-r from-amber-200 to-orange-200 p-4 rounded-xl border-2 border-amber-400 mt-4 shadow-sm">
                        <div className="flex items-center gap-3 mb-3">
                          <div className="p-2 bg-amber-600 rounded-lg">
                            <Calendar className="h-4 w-4 text-white" />
                          </div>
                          <div>
                            <h4 className="font-bold text-amber-900 text-sm">Période de validité personnalisée</h4>
                            <p className="text-xs text-amber-800">Super Admin - Modifier les dates de la souscription</p>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-2 mb-3">
                          <input 
                            type="checkbox" 
                            id="enableCustomPeriod"
                            checked={validitePersonnalisee.enabled}
                            onChange={(e) => setValiditePersonnalisee(prev => ({ ...prev, enabled: e.target.checked }))}
                            className="h-4 w-4 rounded border-amber-300 text-amber-600 focus:ring-amber-500"
                          />
                          <label htmlFor="enableCustomPeriod" className="text-sm font-medium text-amber-700">
                            Activer la période personnalisée
                          </label>
                        </div>
                        
                        {validitePersonnalisee.enabled && (
                          <div className="space-y-3 pt-2 border-t border-amber-200">
                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <Label className="text-xs font-semibold text-amber-700 mb-1 block">Date de début</Label>
                                <DatePickerFr
                                  value={validitePersonnalisee.date_debut}
                                  onChange={(v) => setValiditePersonnalisee(prev => ({ ...prev, date_debut: v }))}
                                  className="border-amber-300 focus:border-amber-500 text-sm h-9 w-full"
                                />
                              </div>
                              <div>
                                <Label className="text-xs font-semibold text-amber-700 mb-1 block">Date de fin</Label>
                                <DatePickerFr
                                  value={validitePersonnalisee.date_fin}
                                  onChange={(v) => setValiditePersonnalisee(prev => ({ ...prev, date_fin: v }))}
                                  className="border-amber-300 focus:border-amber-500 text-sm h-9 w-full"
                                />
                              </div>
                            </div>
                            <div>
                              <Label className="text-xs font-semibold text-amber-700 mb-1 block">Ou durée en jours</Label>
                              <Input
                                type="number"
                                placeholder="365"
                                value={validitePersonnalisee.validite_jours}
                                onChange={(e) => setValiditePersonnalisee(prev => ({ ...prev, validite_jours: parseInt(e.target.value) || 365 }))}
                                className="border-amber-300 focus:border-amber-500 text-sm h-9"
                                min="1"
                                max="3650"
                              />
                            </div>
                            <p className="text-xs text-amber-600 italic">
                              Ces dates seront appliquées à la souscription générée
                            </p>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Panneau de personnalisation des montants - Super Admin uniquement */}
                    {isSuperAdmin && (
                      <div className="bg-gradient-to-r from-emerald-200 to-teal-200 p-4 rounded-xl border-2 border-emerald-400 mt-4 shadow-sm">
                        <div className="flex items-center gap-3 mb-3">
                          <div className="p-2 bg-emerald-600 rounded-lg">
                            <Calculator className="h-4 w-4 text-white" />
                          </div>
                          <div>
                            <h4 className="font-bold text-emerald-900 text-sm">Personnalisation des montants</h4>
                            <p className="text-xs text-emerald-800">Super Admin - Ajuster CA, Montant de base, Montant de la contribution et appliquer une remise (% et/ou €)</p>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-2 mb-3">
                          <input 
                            type="checkbox" 
                            id="enableCustomAmounts"
                            checked={montantsPersonnalises.enabled}
                            onChange={(e) => setMontantsPersonnalises(prev => ({ ...prev, enabled: e.target.checked }))}
                            className="h-4 w-4 rounded border-emerald-300 text-emerald-600 focus:ring-emerald-500"
                          />
                          <label htmlFor="enableCustomAmounts" className="text-sm font-medium text-emerald-700">
                            Activer la personnalisation des montants
                          </label>
                        </div>
                        
                        {montantsPersonnalises.enabled && (
                          <div className="space-y-3 pt-2 border-t border-emerald-200">
                            <div className="grid grid-cols-3 gap-3">
                              <div>
                                <Label className="text-xs font-semibold text-emerald-700 mb-1 block">
                                  CA personnalisé (€)
                                </Label>
                                <Input
                                  type="number"
                                  min="0"
                                  step="100"
                                  placeholder={formData.ca_ht || "Ex: 50000"}
                                  value={montantsPersonnalises.ca_personnalise}
                                  onChange={(e) => setMontantsPersonnalises(prev => ({ ...prev, ca_personnalise: e.target.value }))}
                                  className="border-emerald-300 focus:border-emerald-500 text-sm h-9"
                                  data-testid="input-ca-personnalise"
                                />
                              </div>
                              <div>
                                <Label className="text-xs font-semibold text-emerald-700 mb-1 block">
                                  Remise (%)
                                </Label>
                                <Input
                                  type="number"
                                  min="0"
                                  max="100"
                                  step="0.5"
                                  placeholder="Ex: 10"
                                  value={montantsPersonnalises.remise_pourcentage}
                                  onChange={(e) => setMontantsPersonnalises(prev => ({ ...prev, remise_pourcentage: e.target.value }))}
                                  className="border-emerald-300 focus:border-emerald-500 text-sm h-9"
                                  data-testid="input-remise-pourcentage"
                                />
                              </div>
                              <div>
                                <Label className="text-xs font-semibold text-emerald-700 mb-1 block">
                                  Remise (€)
                                </Label>
                                <Input
                                  type="number"
                                  min="0"
                                  step="10"
                                  placeholder="Ex: 50"
                                  value={montantsPersonnalises.remise_euros || ''}
                                  onChange={(e) => setMontantsPersonnalises(prev => ({ ...prev, remise_euros: e.target.value }))}
                                  className="border-emerald-300 focus:border-emerald-500 text-sm h-9"
                                  data-testid="input-remise-euros"
                                />
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <Label className="text-xs font-semibold text-emerald-700 mb-1 block">
                                  Montant de base personnalisé (€)
                                </Label>
                                <Input
                                  type="number"
                                  min="0"
                                  step="10"
                                  placeholder={resultat?.montant_ht?.toFixed(2) || "Ex: 1500"}
                                  value={montantsPersonnalises.montant_ht_personnalise}
                                  onChange={(e) => setMontantsPersonnalises(prev => ({ ...prev, montant_ht_personnalise: e.target.value }))}
                                  className="border-emerald-300 focus:border-emerald-500 text-sm h-9"
                                />
                              </div>
                              <div>
                                <Label className="text-xs font-semibold text-emerald-700 mb-1 block">
                                  Montant contribution solidaire (€)
                                </Label>
                                <Input
                                  type="number"
                                  min="0"
                                  step="10"
                                  placeholder={resultat?.montant_ttc?.toFixed(2) || "Ex: 1627.50"}
                                  value={montantsPersonnalises.montant_ttc_personnalise}
                                  onChange={(e) => setMontantsPersonnalises(prev => ({ ...prev, montant_ttc_personnalise: e.target.value }))}
                                  className="border-emerald-300 focus:border-emerald-500 text-sm h-9"
                                />
                              </div>
                            </div>
                            
                            {/* Aperçu des montants personnalisés */}
                            {(montantsPersonnalises.ca_personnalise || montantsPersonnalises.montant_ht_personnalise || montantsPersonnalises.montant_ttc_personnalise || montantsPersonnalises.remise_pourcentage || montantsPersonnalises.remise_euros) && (
                              <div className="mt-3 p-3 bg-emerald-100 rounded-lg border border-emerald-300" data-testid="apercu-montants-personnalises">
                                <p className="text-xs font-bold text-emerald-800 mb-2">📊 Aperçu des montants personnalisés :</p>
                                <div className="grid grid-cols-2 gap-2 text-xs">
                                  {montantsPersonnalises.ca_personnalise && (
                                    <div className="flex justify-between">
                                      <span className="text-emerald-700">CA :</span>
                                      <span className="font-bold text-emerald-900">{parseFloat(montantsPersonnalises.ca_personnalise).toLocaleString('fr-FR')} €</span>
                                    </div>
                                  )}
                                  {montantsPersonnalises.remise_pourcentage && (
                                    <div className="flex justify-between">
                                      <span className="text-emerald-700">Remise % :</span>
                                      <span className="font-bold text-red-600">-{montantsPersonnalises.remise_pourcentage}%</span>
                                    </div>
                                  )}
                                  {montantsPersonnalises.remise_euros && (
                                    <div className="flex justify-between">
                                      <span className="text-emerald-700">Remise € :</span>
                                      <span className="font-bold text-red-600">-{parseFloat(montantsPersonnalises.remise_euros).toLocaleString('fr-FR')} €</span>
                                    </div>
                                  )}
                                  {montantsPersonnalises.montant_ht_personnalise && (
                                    <div className="flex justify-between">
                                      <span className="text-emerald-700">HT :</span>
                                      <span className="font-bold text-emerald-900">{parseFloat(montantsPersonnalises.montant_ht_personnalise).toLocaleString('fr-FR')} €</span>
                                    </div>
                                  )}
                                  {montantsPersonnalises.montant_ttc_personnalise && (
                                    <div className="flex justify-between">
                                      <span className="text-emerald-700">Global :</span>
                                      <span className="font-bold text-emerald-900">{parseFloat(montantsPersonnalises.montant_ttc_personnalise).toLocaleString('fr-FR')} €</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                            
                            <p className="text-xs text-emerald-600 italic">
                              Ces montants seront utilisés à la place des valeurs calculées automatiquement
                            </p>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Panneau de personnalisation des Taxes et Contributions - Super Admin uniquement */}
                    {isSuperAdmin && (
                      <div className="bg-gradient-to-r from-purple-200 to-indigo-200 p-4 rounded-xl border-2 border-purple-400 mt-4 shadow-sm">
                        <div className="flex items-center gap-3 mb-3">
                          <div className="p-2 bg-purple-600 rounded-lg">
                            <List className="h-4 w-4 text-white" />
                          </div>
                          <div>
                            <h4 className="font-bold text-purple-900 text-sm">Personnalisation des Contributions solidaires</h4>
                            <p className="text-xs text-purple-800">Super Admin - Modifier les rubriques, taux et montants</p>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-2 mb-3">
                          <input 
                            type="checkbox" 
                            id="enableCustomTaxes"
                            checked={taxesPersonnalisees.enabled}
                            onChange={(e) => setTaxesPersonnalisees(prev => ({ ...prev, enabled: e.target.checked }))}
                            className="h-4 w-4 rounded border-purple-300 text-purple-600 focus:ring-purple-500"
                          />
                          <label htmlFor="enableCustomTaxes" className="text-sm font-medium text-purple-700">
                            Activer la personnalisation des taxes/contributions
                          </label>
                        </div>
                        
                        {taxesPersonnalisees.enabled && (
                          <div className="space-y-3 pt-2 border-t border-purple-200">
                            {/* En-tête des colonnes */}
                            <div className="grid grid-cols-12 gap-2 text-xs font-semibold text-purple-700 mb-1">
                              <div className="col-span-5">Libellé</div>
                              <div className="col-span-2 text-center">Taux (%)</div>
                              <div className="col-span-3 text-center">Montant (€)</div>
                              <div className="col-span-1 text-center">Actif</div>
                              <div className="col-span-1"></div>
                            </div>
                            
                            {/* Lignes de taxes */}
                            {taxesPersonnalisees.lignes.map((ligne) => (
                              <div key={ligne.id} className="grid grid-cols-12 gap-2 items-center">
                                <div className="col-span-5">
                                  <Input
                                    type="text"
                                    placeholder="Nom de la taxe/contribution"
                                    value={ligne.nom}
                                    onChange={(e) => updateLigneTaxe(ligne.id, 'nom', e.target.value)}
                                    className="border-purple-300 focus:border-purple-500 text-xs h-8"
                                  />
                                </div>
                                <div className="col-span-2">
                                  <Input
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="0.1"
                                    placeholder="Taux"
                                    value={ligne.taux}
                                    onChange={(e) => updateLigneTaxe(ligne.id, 'taux', e.target.value)}
                                    className="border-purple-300 focus:border-purple-500 text-xs h-8 text-center"
                                  />
                                </div>
                                <div className="col-span-3">
                                  {/* Montant calculé automatiquement OU montant fixe saisi */}
                                  {(() => {
                                    const montantHT = getMontantsFinals()?.montant_ht || resultat?.montant_ht || 0;
                                    // Arrondi cohérent ROUND_HALF_UP (identique à `.toLocaleString` et au backend)
                                    const roundHalfUp = (v) => Math.round((v + Number.EPSILON) * 100) / 100;
                                    const montantCalculeBrut = ligne.taux && montantHT > 0 ? (montantHT * parseFloat(ligne.taux) / 100) : 0;
                                    const montantCalcule = roundHalfUp(montantCalculeBrut);
                                    const formatEUR = (v) => v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                    return (
                                      <div className="relative">
                                        <Input
                                          type="number"
                                          min="0"
                                          step="0.01"
                                          placeholder={montantCalcule > 0 ? montantCalcule.toFixed(2) : "0.00"}
                                          value={ligne.montant}
                                          onChange={(e) => updateLigneTaxe(ligne.id, 'montant', e.target.value)}
                                          className={`border-purple-300 focus:border-purple-500 text-xs h-8 text-center ${!ligne.montant && montantCalcule > 0 ? 'placeholder:text-purple-600 placeholder:font-semibold' : ''}`}
                                        />
                                        {!ligne.montant && montantCalcule > 0 && (
                                          <span className="absolute -bottom-4 left-0 text-[10px] text-purple-500">
                                            auto: {formatEUR(montantCalcule)}€
                                          </span>
                                        )}
                                      </div>
                                    );
                                  })()}
                                </div>
                                <div className="col-span-1 flex justify-center">
                                  <input
                                    type="checkbox"
                                    checked={ligne.actif}
                                    onChange={(e) => updateLigneTaxe(ligne.id, 'actif', e.target.checked)}
                                    className="h-4 w-4 rounded border-purple-300 text-purple-600 focus:ring-purple-500"
                                  />
                                </div>
                                <div className="col-span-1 flex justify-center">
                                  <button
                                    type="button"
                                    onClick={() => supprimerLigneTaxe(ligne.id)}
                                    className="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded"
                                    title="Supprimer cette ligne"
                                  >
                                    <Trash2 className="h-4 w-4" />
                                  </button>
                                </div>
                              </div>
                            ))}
                            
                            {/* Bouton ajouter une ligne */}
                            <button
                              type="button"
                              onClick={ajouterLigneTaxe}
                              className="w-full py-2 border-2 border-dashed border-purple-300 rounded-lg text-purple-600 hover:bg-purple-50 hover:border-purple-400 text-xs font-medium flex items-center justify-center gap-2 transition-colors"
                            >
                              <Plus className="h-4 w-4" />
                              Ajouter une ligne
                            </button>
                            
                            {/* Aperçu du total */}
                            {taxesPersonnalisees.lignes.some(l => l.actif && l.nom) && (
                              <div className="mt-3 p-3 bg-purple-100 rounded-lg border border-purple-300">
                                <p className="text-xs font-bold text-purple-800 mb-2">📋 Aperçu des taxes personnalisées :</p>
                                <div className="space-y-1 text-xs">
                                  {(() => {
                                    // Arrondi ROUND_HALF_UP cohérent avec l'input et le backend.
                                    // Garantit Σ(lignes affichées) == Total taxes affiché.
                                    const roundHalfUp = (v) => Math.round((v + Number.EPSILON) * 100) / 100;
                                    const formatEUR = (v) => v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                    const montantHT = getMontantsFinals()?.montant_ht || resultat?.montant_ht || 0;
                                    const lignesActives = taxesPersonnalisees.lignes.filter(l => l.actif && l.nom);
                                    const lignesArrondies = lignesActives.map((l) => {
                                      const brut = l.montant
                                        ? parseFloat(l.montant)
                                        : (l.taux ? montantHT * parseFloat(l.taux) / 100 : 0);
                                      return { ...l, montantArrondi: roundHalfUp(brut) };
                                    });
                                    const totalArrondi = lignesArrondies.reduce((sum, l) => sum + l.montantArrondi, 0);
                                    return (
                                      <>
                                        {lignesArrondies.map((l) => (
                                          <div key={l.id} className="flex justify-between" data-testid={`taxe-preview-${l.id}`}>
                                            <span className="text-purple-700">{l.nom} {l.taux ? `(${l.taux}%)` : ''}</span>
                                            <span className="font-bold text-purple-900">{formatEUR(l.montantArrondi)} €</span>
                                          </div>
                                        ))}
                                        <div className="flex justify-between border-t border-purple-300 pt-1 mt-1" data-testid="taxe-preview-total">
                                          <span className="font-bold text-purple-800">Total taxes :</span>
                                          <span className="font-bold text-purple-900">
                                            {formatEUR(totalArrondi)} €
                                          </span>
                                        </div>
                                      </>
                                    );
                                  })()}
                                </div>
                              </div>
                            )}
                            
                            <p className="text-xs text-purple-600 italic">
                              Ces contributions seront affichées dans tous les documents générés (proposition, devis, reçu)
                            </p>
                          </div>
                        )}
                      </div>
                    )}

    </>
  );
}
